import { Formik } from 'formik';
import TextArea from 'components/form/TextArea';
import FileUpload from 'components/form/FileUpload';
import Button from 'components/form/Button';
import { getDataFromLocalStorage } from 'utils/helpers';
import { useSelector } from 'react-redux';

const ActionForm = ({
  formikRef,
  initialValues,
  validationSchema,
  isRejecting,
  handleReject,
  handleApproveRequest,
  setIsRejecting,
  onHide,
  btnLoading,
}) => {
  const userType = getDataFromLocalStorage('user_type');
  // Redux state
  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));

  const { create: createAccess } =
    userDetails?.role_data?.find((item) => item?.permission_name === 'Requests')
      ?.sub_permission || {};

  return (
    <>
      <Formik
        innerRef={formikRef || undefined}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setErrors }) => {
          if (isRejecting) {
            handleReject(values, setErrors);
          } else {
            handleApproveRequest(values, setErrors);
          }
        }}
      >
        {(props) => {
          const { values, errors, handleChange, handleSubmit, setFieldValue } =
            props;

          return (
            <form>
              <div className="cmt-20">
                <TextArea
                  label="Comment"
                  name="comment"
                  value={values.comment}
                  onChange={handleChange}
                  labelClass="color-4141"
                />
              </div>
              <div className="cmt-20">
                <FileUpload
                  label="Upload Supporting Document"
                  id="document"
                  value={values.document}
                  onChange={(e) => setFieldValue(e.target.id, e.target.value)}
                  fileType="image,pdf"
                  labelClass="color-4141"
                />
              </div>

              {(errors.document || errors.comment) && (
                <div className="text-12-400-15 color-4646 cmt-10">
                  * Either comment or upload media file is mandatory
                </div>
              )}

              {/* ✅ Show buttons only if formikRef is NOT passed (used from inside) */}
              {!formikRef && (
                <div className="d-flex gap-3 cmt-20">
                  {createAccess && (
                    <>
                      <Button
                        text={
                          userType === '1' ? 'Approve Request' : 'Send Request'
                        }
                        btnStyle="primary-dark"
                        className="h-37 text-14-500 cps-20 cpe-20"
                        onClick={() => {
                          setIsRejecting(false);
                          handleSubmit();
                        }}
                        disabled={btnLoading}
                      />
                      <Button
                        text="Reject"
                        btnStyle="primary-light-outline"
                        className="h-37 text-14-500 cps-20 cpe-20"
                        onClick={() => {
                          setIsRejecting(true);
                          handleSubmit();
                        }}
                        disabled={btnLoading}
                      />
                    </>
                  )}
                  <Button
                    text="Cancel"
                    btnStyle="light-outline"
                    className="h-37 text-14-500 cps-20 cpe-20"
                    onClick={onHide}
                    disabled={btnLoading}
                  />
                </div>
              )}
            </form>
          );
        }}
      </Formik>

      {userType === '0' && !formikRef && (
        <div className="d-flex gap-2 cmt-10">
          <i className="bi bi-info-circle" />
          <span className="text-12-400-15 color-4141">
            This send request will be considered as an approval from the admin
            and will be shared with the super admin.
          </span>
        </div>
      )}
    </>
  );
};

export default ActionForm;

// import { Formik } from 'formik';
// import TextArea from 'components/form/TextArea';
// import FileUpload from 'components/form/FileUpload';

// const ActionForm = ({
//   formikRef,
//   initialValues,
//   validationSchema,
//   isRejecting,
//   handleReject,
//   handleApproveRequest,
// }) => (
//   <Formik
//     innerRef={formikRef}
//     initialValues={initialValues}
//     validationSchema={validationSchema}
//     onSubmit={(values, { setErrors }) => {
//       if (isRejecting) {
//         handleReject(values, setErrors);
//       } else {
//         handleApproveRequest(values, setErrors);
//       }
//     }}
//   >
//     {(props) => {
//       const { values, errors, handleChange, setFieldValue } = props;
//       return (
//         <form>
//           <TextArea
//             label="Comment"
//             name="comment"
//             value={values.comment}
//             onChange={handleChange}
//           />
//           <FileUpload
//             label="Upload Supporting Document"
//             id="document"
//             value={values.document}
//             onChange={(e) => setFieldValue(e.target.id, e.target.value)}
//             fileType="image,pdf"
//           />
//           {(errors.document || errors.comment) && (
//             <div className="text-12-400-15 color-4646 cmt-10">
//               * Either comment or upload media file is mandatory
//             </div>
//           )}
//         </form>
//       );
//     }}
//   </Formik>
// );

// export default ActionForm
